"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchRequest = void 0;
class FetchRequest {
    constructor(args) {
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: args
        });
    }
    async post(path, data, keepalive = false) {
        if (fetch) {
            return fetch(`${this.args.baseURL}/${path}`, {
                keepalive,
                method: 'POST',
                mode: 'cors',
                headers: this.args.headers,
                body: JSON.stringify(data),
            });
        }
        return null;
    }
}
exports.FetchRequest = FetchRequest;
